module.exports = __webpack_public_path__ + "img/frame_medium_bot.6b36a514.png";